import objectAssign from "core-js/modules/es6.object.assign";
if (!Object.assign) Object.assign = objectAssign;

import objectValues from "core-js/modules/es7.object.values";
if (!(Object as any).values) (Object as any).values = objectValues;

import find from "core-js/modules/es6.array.find";
if (!Array.prototype.find) Array.prototype.find = find;

import map from "core-js/modules/es6.array.map";
if (!Array.prototype.map) Array.prototype.map = map;

import filter from "core-js/modules/es6.array.filter";
if (!Array.prototype.filter) Array.prototype.filter = filter;

import some from "core-js/modules/es6.array.some";
if (!Array.prototype.some) Array.prototype.some = some;

if (!NodeList.prototype.forEach) (NodeList.prototype as any).forEach = Array.prototype.forEach;
